import { isFiniteNumber } from './untils';

const DEFAULT_DRAG_ACTIVATION_DISTANCE_PX = 6;

/**
 * Returns pointer travel distance in pixels between start and current positions.
 */
export function getPointerDistance({
  startX,
  startY,
  currentX,
  currentY,
}: {
  startX: number;
  startY: number;
  currentX: number;
  currentY: number;
}): number {
  if (
    !isFiniteNumber(startX) ||
    !isFiniteNumber(startY) ||
    !isFiniteNumber(currentX) ||
    !isFiniteNumber(currentY)
  ) {
    return 0;
  }

  const deltaX = currentX - startX;
  const deltaY = currentY - startY;

  return Math.hypot(deltaX, deltaY);
}

/**
 * Drag starts only after the pointer has moved enough distance.
 */
export function shouldStartDrag({
  startX,
  startY,
  currentX,
  currentY,
  activationDistancePx = DEFAULT_DRAG_ACTIVATION_DISTANCE_PX,
}: {
  startX: number;
  startY: number;
  currentX: number;
  currentY: number;
  activationDistancePx?: number;
}): boolean {
  if (
    !isFiniteNumber(startX) ||
    !isFiniteNumber(startY) ||
    !isFiniteNumber(currentX) ||
    !isFiniteNumber(currentY)
  ) {
    return false;
  }

  if (activationDistancePx <= 0) return true;

  const pointerDistance = getPointerDistance({
    startX,
    startY,
    currentX,
    currentY,
  });

  return pointerDistance >= activationDistancePx;
}
